import type { SpaceGits } from "@indietabletop/types";

export type Ref = SpaceGits.TreatmentRef | SpaceGits.RepairRef | SpaceGits.Ref;

export function refToUniqueKey(ref: Ref) {
  if ("locationId" in ref) {
    return `${ref.locationId}/${ref.id}`;
  }

  return ref.id;
}

export function uniqueKeyToRef(key: string) {
  const [locationId, id] = key.split("/") as [string, string];
  return { locationId, id };
}
